import { render } from "./PerkConfigsMembership.vue?vue&type=template&id=8499fa78"
import script from "./PerkConfigsMembership.vue?vue&type=script&lang=js"
export * from "./PerkConfigsMembership.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__